import BaseComponent from './basecomponent';


export default class ListSubmenuOverlay extends BaseComponent {
    static get DEFAULTS() {
        return {
            containerSelector: '#overlaySubMenu',       // Selettore contenitore overlay
            wrapperSelector: '#overlaySubMenuContent',  // Selettore wrapper del contenuto dell'overlay
            triggersSelector: '.trigger-overlay',       // Selettore dei trigger che aprono l'overlay
            closeBtnSelection: '.overlayClose',         // Selettore del tasto chiudi
            sectionDataAttr: 'section',                 // Nome dell'attributo 'data-' che contiene l'id della sezione/submenu da aprire
            overlayOpenClass: "open",                   // Classe da associare al contenitore dell'overlay quando aperto
            overlayCloseClass: "close",                 // Classe da associare al contenitore dell'overlay quando chiuso
            overlayOpenBodyClass: 'submenuOverlayOpen', // Classe da associare al body quando l'overlay è aperto
            transitionsDuration: false                  // Durata delle animazioni in secondi (come transizione fra un menu e un altro) (es. 1.0). 0 o false per disattivare le animazioni
        }
    }

    /**
     * Inizializza l'overlay menu
     * @param options Opzioni, vedi ListSubmenuOverlay.DEFAULTS
     */
    constructor(options) {
        super();
        this.options = $.extend(true, {}, ListSubmenuOverlay.DEFAULTS, options);
        this._isOpen = false;
    }

    /**
     * Avvia il rendering del componente
     * @param templateRenderCallback Funzione callback (con signature (submenuId) => htmlOverlay) che restituisce l'html del menu selezionato
     */
    render(templateRenderCallback=null) {
        this.$body = $('body');
        this.$container = $(this.options.containerSelector);
        this.$wrapper = $(this.options.wrapperSelector);
        this.$triggers = $(this.options.triggersSelector);
        this.$closeBtn = this.$container.find(this.options.closeBtnSelection);

        this._templateRenderCallback = templateRenderCallback;

        this._addClickHandlers();
        this._disableScrollEvents();
    }

    /**
     * Apre il menu indicato da dal parametro submenuId
     * @param submenuId L'id del menu, il contenitore del
     */
    open(submenuId) {
        var overlayHtml;

        if (typeof this._templateRenderCallback === 'function') {
            overlayHtml = this._templateRenderCallback.call(this, submenuId);
        } else {
            let $submenu = $('[data-'+this.options.sectionDataAttr+'="' + submenuId + '"]');
            overlayHtml = $submenu.find('.secondLevel').html();
        }

        // Set content
        if (this.options.transitionsDuration) {
            var duration = this.options.transitionsDuration * 1000;
            this.$wrapper.fadeOut(duration, () => {
                this.$wrapper.html(overlayHtml);
                this.$wrapper.fadeIn(duration);
            });
        }else {
            this.$wrapper.html(overlayHtml);
        }

        // Update attributes
        this.$container.addClass(this.options.overlayOpenClass);
        this.$container.attr('data-'+this.options.sectionDataAttr, submenuId);
        this.$body.addClass(this.options.overlayOpenBodyClass);
        this._isOpen = true;
    }

    /**
     * Chiude l'overlay menu
     */
    close() {
        this.$container.removeClass(this.options.overlayOpenClass);
        this.$container.addClass(this.options.overlayCloseClass);
        this.$body.removeClass(this.options.overlayOpenBodyClass);
        this._isOpen = false;
    }

    /**
     * Restituisce true se l'overlay è aperto
     * @returns {boolean}
     */
    isOpen() {
        return this._isOpen === true;
    }

    /**
     * Imposta gli handler per i click sui triggers e sul tasto chiudi dell'overlay
     * @private
     */
    _addClickHandlers() {
        this.$triggers.click((e) => {
            e.preventDefault();
            let $trigger = $(e.delegateTarget);
            let submenuId = $trigger.data(this.options.sectionDataAttr);

            this.open(submenuId);
        });

        this.$closeBtn.click((e) => {
            e.preventDefault();
            this.close();
        });
    }

    /**
     * Disabilita lo scrolling della pagina
     * @private
     */
    _disableScrollEvents() {
        this.$container.on({
            'mousewheel': function(e) {
                e.preventDefault();
            },
            'wheel': function(e) {
                e.preventDefault();
            },
            'touchmove': function(e) {
                e.preventDefault();
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/listsubmenuoverlay.js
 **/